export default __webpack_public_path__ + "static/media/gallery-wip-weathering_01.61bb89fd.jpg";